import Vue from 'vue';
import App from './Commentoid';
import router from './router';
import store from './store/index';
import Vue2Filters from 'vue2-filters';
import VueLodash from 'vue-lodash';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import VueTimeago from 'vue-timeago';
import VueMeta from 'vue-meta';

var VueScrollTo = require('vue-scrollto');
var VueCookie = require('vue-cookie');

Vue.config.productionTip = false;

// Vue plugins
Vue.use(Vue2Filters);
Vue.use(VueLodash);
Vue.use(VueRouter);
Vue.use(Vuelidate);
Vue.use(VueCookie);
Vue.use(VueScrollTo, {
   container: "#landing",
   duration: 1200,
   easing: "ease",
   offset: 0,
   force: true,
   cancelable: true,
   onStart: false,
   onDone: false,
   onCancel: false,
   x: false,
   y: true
});
Vue.use(VueTimeago, {
  name: 'Timeago',
  locale: 'en'
});
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

// * Load Components *
// -- Common
import TabBar from '@/components/common/form/TabBar';
Vue.component('tab-bar', TabBar);

import TabButton from '@/components/common/form/TabButton';
Vue.component('tab-button', TabButton);

import RTXSpinner from '@/components/common/RTXSpinner.vue';
Vue.component('rtx-spinner', RTXSpinner);

import SiteHeader from '@/components/common/Header.vue';
Vue.component('site-header', SiteHeader);

import SiteFooter from '@/components/common/Footer';
Vue.component('site-footer', SiteFooter);

// -- Site
import ScheduleDemo from '@/components/site/ScheduleDemo';
Vue.component('schedule-demo', ScheduleDemo);

import Entry from '@/components/site/Entry';
Vue.component('ctd-entry', Entry);

import Comment from '@/components/site/Comment';
Vue.component('ctd-comment', Comment);

/* eslint-disable no-new */
new Vue({
   el: '#app',
   router,
   store,
   render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js